const dimensions = {
  imperialDimX: [5, 10, 15, 20, 25, 30, 35, 40, 45],
  imperialDimY: [32, 30, 28, 26, 24, 22, 20, 18, 16, 14, 12, 10, 5],
  imperialValues: [
    [124, 108, 93, 82, 72, 64, 57, 52, 49],
    [160, 140, 123, 110, 99, 89, 81, 75, 70],
    [161, 152, 133, 118, 105, 94, 85, 78, 73],
    [161, 161, 148, 130, 116, 104, 94, 86, 80],
    [161, 161, 161, 142, 126, 113, 102, 93, 87],
    [161, 161, 161, 152, 134, 120, 108, 99, 92],
    [161, 161, 161, 161, 147, 128, 116, 105, 97],
    [161, 161, 161, 161, 155, 135, 122, 111, 102],
    [161, 161, 161, 161, 161, 143, 128, 116, 106],
    [161, 161, 161, 161, 161, 153, 134, 121, 111],
    [161, 161, 161, 161, 161, 160, 143, 130, 119],
    [161, 161, 161, 161, 161, 161, 148, 133, 122],
    [161, 161, 161, 161, 161, 161, 161, 143, 128]
  ],
  metricDimX: [12.7, 25.4, 38.1, 50.8, 63.5, 76.2, 88.9, 101.6, 114.3],
  metricDimY: [81.28, 76.2, 71.12, 66.04, 60.96, 55.88, 50.8, 45.72, 40.64, 35.56, 30.48, 25.4, 12.7],
  metricValues: [
    ["314.96", "274.32", "236.22", "208.28", "182.88", "162.56", "144.78", "132.08", "124.46"],
    ["406.4", "355.6", "312.42", "279.4", "251.46", "226.06", "205.74", "190.5", "177.8"],
    ["408.94", "386.08", "337.82", "299.72", "266.7", "238.76", "213.36", "198.12", "185.42"],
    ["408.94", "408.94", "375.92", "330.2", "294.64", "264.16", "238.76", "218.44", "203.2"],
    ["408.94", "408.94", "408.94", "360.68", "320.04", "287.02", "259.08", "236.22", "220.98"],
    ["408.94", "408.94", "408.94", "386.08", "340.36", "304.8", "274.32", "251.46", "233.68"],
    ["408.94", "408.94", "408.94", "408.94", "373.38", "325.12", "294.64", "266.7", "246.38"],
    ["408.94", "408.94", "408.94", "408.94", "393.7", "342.9", "309.88", "281.94", "259.08"],
    ["408.94", "408.94", "408.94", "408.94", "408.94", "363.22", "325.12", "294.64", "269.24"],
    ["408.94", "408.94", "408.94", "408.94", "408.94", "388.62", "340.36", "307.34", "269.24"],
    ["408.94", "408.94", "408.94", "408.94", "408.94", "406.4", "363.22", "330.2", "302.26"],
    ["408.94", "408.94", "408.94", "408.94", "408.94", "408.94", "375.92", "337.82", "309.88"],
    ["408.94", "408.94", "408.94", "408.94", "408.94", "408.94", "408.94", "363.22", "325.12"]
  ]
};

export default dimensions;


// WEBPACK FOOTER //
// ./src/components/SizeCalculator/dimensions.js